import React from 'react'
import TextField from './../../shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import SelectField from "../../shared/components/fields/selectField/SelectField";
import Alert from '../../shared/components/alerts/Alert';
import FormButtons from "../../shared/components/others/formButtons/FormButtons";
import DateTimeUtils from './../../shared/utils/DateTimeUtils';
import { appModules } from '../../roles/components/UserHasPermission';

const UsersForm = ({
                       userFormData: {
                           firstName,
                           lastName,
                           email,
                           status,
                           language,
                           timezone,
                           entity,
                           role
                       },
                       alert,
                       editMode,
                       createMode,
                       viewMode,
                       personalAreaMode,
                       hasDelete,
                       entityList,
                       roleList,
                       handleFieldChange,
                       handleOnFieldBlur,
                       handleSubmitClick,
                       handleBackClick,
                       handleEditClick,
                       handleDeleteClick,
                   }) => {
    const timeZoneData = DateTimeUtils.getTimezoneDataForDropdown();
    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            { !personalAreaMode && <div className="header">
                {buildHeader(createMode, editMode, viewMode)}
            </div>}
            <div className="fields">
                <div id="user-fields-1" className="field-row">
                    <div className="row">
                        <TextField
                            value={firstName.value}
                            label={I18n.t("users.form.firstName.label")}
                            handleFieldChange={value => handleFieldChange("firstName", value)}
                            handleFieldBlur={() => handleOnFieldBlur("firstName")}
                            themeName="form"
                            error={firstName.error}
                            disabled={viewMode}
                            width={4}
                        />
                        <TextField
                            value={lastName.value}
                            label={I18n.t("users.form.lastName.label")}
                            handleFieldChange={value => handleFieldChange("lastName", value)}
                            handleFieldBlur={() => handleOnFieldBlur("lastName")}
                            themeName="form"
                            error={lastName.error}
                            disabled={viewMode}
                            width={4}
                        />
                    </div>
                    <div className="row">
                        <TextField
                            value={email.value}
                            label={I18n.t("users.form.email.label")}
                            handleFieldChange={value => handleFieldChange("email", value)}
                            handleFieldBlur={() => handleOnFieldBlur("email")}
                            themeName="form"
                            error={email.error}
                            disabled={!createMode}
                            width={4}
                        />
                        <SelectField
                            value={status.value}
                            label={I18n.t("users.form.status.label")}
                            handleFieldChange={value => handleFieldChange("status", value)}
                            options={[
                                { value: "ACTIVE", label: I18n.t("users.form.status.enabled") },
                                { value: "INACTIVE", label: I18n.t("users.form.status.disabled") },
                            ]}
                            error={status.error}
                            disabled={viewMode || personalAreaMode}
                            width={4}
                        />
                    </div>
                    <div className="row">
                        <SelectField
                            value={entity.value}
                            label={I18n.t("users.form.entity.label")}
                            options={entityList}
                            error={entity.error}
                            disabled={viewMode || editMode || personalAreaMode}
                            handleFieldChange={value => handleFieldChange("entity", value)}
                            width={4}
                        />
                        <SelectField
                            value={role.value}
                            label={I18n.t("users.form.role.label")}
                            options={roleList}
                            error={role.error}
                            disabled={viewMode || personalAreaMode}
                            handleFieldChange={value => handleFieldChange("role", value)}
                            width={4}
                        />
                    </div>
                    <div className="row">
                        <SelectField
                            handleFieldChange={value => handleFieldChange("timezone", value)}
                            value={timezone.value}
                            label={I18n.t("users.form.timezone.label")}
                            options={timeZoneData}
                            error={timezone.error}
                            disabled={viewMode}
                            width={4}
                        />
                        <SelectField
                            handleFieldChange={value => handleFieldChange("language", value)}
                            value={language.value}
                            label={I18n.t("users.form.language.label")}
                            options={[
                                { value: "en_US", label: I18n.t("users.form.language.english") },
                            ]}
                            error={language.error}
                            disabled={viewMode}
                            width={4}
                        />
                    </div>
                </div>
            </div>
            {( (createMode && !personalAreaMode) || editMode ) &&
            <div className="buttons">
                <button
                    className=" mt-3 btn btn-primary"
                    onClick={handleSubmitClick}
                >
                    {I18n.t("forms.save")}
                </button>
            </div>
            }
        </div>
        <div className="form-options">
            <FormButtons
                editMode={editMode}
                viewMode={viewMode}
                hasDelete={hasDelete}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                appModule={appModules.USER}
            />
        </div>
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("users.form.headers.create") :
        editMode ?
            I18n.t("users.form.headers.edit") :
            I18n.t("users.form.headers.view");
}

export default UsersForm;